// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"fz-z","modalContent":"gz-z","header":"hz-z","close":"iz-z"};